// src/data/gallery.js
export const galleryData = [
  {
    id: 1,
    title: "Hidden Sun",
    description: "The golden sun peeks through dramatic layers of dark clouds above the treeline",
    category: "Landscape",
    tags: ["sunset", "clouds", "trees", "dramatic"],
    imageUrl: "assets/images/gallery/gallery-hidden_sun.jpg",
    aspectRatio: "4/3",
  },
  {
    id: 2,
    title: "Sky Trail",
    description: "Airplane contrail streaking across brilliant blue sky",
    category: "Landscape",
    tags: ["sky", "clouds", "blue", "contrail"],
    imageUrl: "assets/images/gallery/gallery-sky_trail.jpg",
    aspectRatio: "3/4",
  },
  {
    id: 5,
    title: "Freedom",
    description: "Birds soaring across a cloudy, monochrome sky",
    category: "Coverage",
    tags: ["birds", "sky", "monochrome", "flight"],
    imageUrl: "assets/images/gallery/gallery-freedom.jpg",
    aspectRatio: "4/3",
  },
  {
    id: 6,
    title: "Twilight by the Bay",
    description: "City lights reflecting on calm harbor waters at dusk",
    category: "Urban",
    tags: ["city", "harbor", "lights", "twilight"],
    imageUrl: "assets/images/gallery/gallery-twilight_by_the_bay.jpg",
    aspectRatio: "4/3", 
  },
  {
    id: 7,
    title: "The Narrows",
    description: "A rugged channel framed by glowing lights and fading blue dusk",
    category: "Landscape",
    tags: ["channel", "lights", "dusk", "water"],
    imageUrl: "assets/images/gallery/gallery-the_narrows.jpg",
    aspectRatio: "3/2",
  },
  {
    id: 8,
    title: "Crimson Burst",
    description: "A brilliant red firework explodes against the night sky",
    category: "Nature",
    tags: ["firework", "night", "red", "explosion"],
    imageUrl: "assets/images/gallery/gallery-crimson_burst.jpg",
    aspectRatio: "2/3",
  },
  {
    id: 13,
    title: "Full Moon Treeline",
    description: "Full moon rising above treeline in clear sky",
    category: "Nature",
    tags: ["moon", "trees", "night", "sky"],
    imageUrl: "assets/images/gallery/gallery-full_moon_treeline.jpg",
    aspectRatio: "4/3",
  },
  {
    id: 16,
    title: "Rainbow Streetlamp",
    description: "Rainbow appearing behind streetlamp after storm",
    category: "Urban",
    tags: ["rainbow", "streetlamp", "storm", "urban"],
    imageUrl: "assets/images/gallery/gallery-rainbow_streetlamp.jpg",
    aspectRatio: "3/4",
  },
  {
    id: 18,
    title: "Niagara Bridge",
    description: "Bridge spanning across misty gorge",
    category: "Landscape",
    tags: ["bridge", "mist", "fog", "landscape"],
    imageUrl: "assets/images/gallery/gallery-niagara_bridge.jpg",
    aspectRatio: "4/3",
  },
  {
    id: 19,
    title: "Sparrow Circle",
    description: "Circle of sparrows during feeding time",
    category: "Nature",
    tags: ["sparrows", "birds", "feeding", "circle"],
    imageUrl: "assets/images/gallery/gallery-sparrow_circle.jpg",
    aspectRatio: "1/1",
  },
  {
    id: 20,
    title: "Ferris Wheel",
    description: "Ferris wheel silhouetted against twilight sky",
    category: "Urban",
    tags: ["ferris wheel", "twilight", "silhouette", "urban"],
    imageUrl: "assets/images/gallery/gallery-ferris_wheel.jpg",
    aspectRatio: "4/3",
  },
  {
    id: 21,
    title: "The English Pug",
    description: "Bronze statue of a dapper gentleman holding a pug, standing proudly on a city street",
    category: "Urban",
    tags: ["statue", "bronze", "street", "architecture"],
    imageUrl: "assets/images/gallery/gallery-the_english_pug.jpg",
    aspectRatio: "3/4",
  },
  {
    id: 22,
    title: "Market Vendor",
    description: "A smiling vendor tends his colorful stall adorned with hanging dried chili peppers",
    category: "Coverage",
    tags: ["market", "vendor", "peppers", "street"],
    imageUrl: "assets/images/gallery/gallery-market_vendor.jpg",
    aspectRatio: "3/2",
  },
  {
    id: 23,
    title: "Crossing",
    description: "A woman crosses a busy city street in front of a sleek black Corvette",
    category: "Urban",
    tags: ["street", "city", "pedestrian", "cars"],
    imageUrl: "assets/images/gallery/gallery-crossing.jpg",
    aspectRatio: "3/2",
  },
  {
    id: 24,
    title: "Heart Alley",
    description: "Neon heart sculptures glow on a brick alley wall",
    category: "Urban",
    tags: ["neon", "hearts", "alley", "night"],
    imageUrl: "assets/images/gallery/gallery-heart_alley.jpg",
    aspectRatio: "2/3",
  },
  {
    id: 25,
    title: "Mount Royal Squirrel",
    description: "A grey squirrel pauses among fallen autumn leaves",
    category: "Nature",
    tags: ["squirrel", "autumn", "wildlife", "leaves"],
    imageUrl: "assets/images/gallery/gallery-montreal_squirrel.jpg",
    aspectRatio: "2/3",
  },
];